
'use strict';

import i18n from  "./../Localization/i18n.js";


/**
 * 
 * Resource ID mapping to coding system / alias coding system?
 * 
 - icd10-f  =>          http://documental.ee/fhir/valueset/icd10-f            http://hl7.org/fhir/sid/icd-10
 - age-group =>         http://documental.ee/fhir/valueset/age-group 
 - atc-f =>             http://documental.ee/fhir/valueset/atc-f              http://www.whocc.no/atc
 - medication-form =>   http://documental.ee/fhir/valueset/medication-form
 - medication-group =>  http://documental.ee/fhir/valueset/medication-group
 - indication =>        http://documental.ee/fhir/valueset/indication         http://documental.ee/fhir/codesystem/medication/indication
 - medication-route =>  http://documental.ee/fhir/valueset/medication-route
 - questionnaires =>    http://documental.ee/fhir/valueset/questionnaires     http://documental.ee/fhir/codesystem/questionnaire/type
 
 * @return void
 */
function CodingSystemTranslator () {

  // using global window storage for cahce at moment
  if( typeof window.translations == 'undefined' || typeof window.codingTranslationsLoaded == 'undefined' ){
    window.translations = [];
    window.questionnaireItemTranslations = [];
    window.codingTranslationsLoaded = false;
  }
  
}


/**
 * Translate given code object's display value returning pure code object back based on original
 * 
 */
CodingSystemTranslator.prototype.codeObjectToCurrentLanguage = function( codeObj ){
  this.maybeLoadTranslationsFromValueSets();
  
  // If code or coding system is missing- cant translate, return original obj back
  if( 
    !codeObj || typeof codeObj.code == 'undefined' || 
    typeof codeObj.system == 'undefined' || 
    codeObj.code == ''|| 
    codeObj.system == ''
  ){
    return codeObj;
  }

  let lang = i18n.language;
  let display = codeObj.display;

  let translated = this.getTranslatedDisplayForCodeAndLanguage( lang, codeObj.system, codeObj.code );
  if( translated != null ){
    display = translated;
  }

  return {
    code : codeObj.code,
    display : display,
    system : codeObj.system
  };
}


/**
 * Translate given code object's display value returning pure code object back based on original
 * 
 */
CodingSystemTranslator.prototype.codeObjectToLanguage = function( codeObj, languageCode ){
  this.maybeLoadTranslationsFromValueSets();
  
  // If code or coding system is missing- cant translate, return original obj back
  if( 
    !codeObj || typeof codeObj.code == 'undefined' || 
    typeof codeObj.system == 'undefined' || 
    codeObj.code == ''|| 
    codeObj.system == ''
  ){
    return codeObj;
  }

  let lang = languageCode;
  let display = codeObj.display;

  let translated = this.getTranslatedDisplayForCodeAndLanguage( lang, codeObj.system, codeObj.code );
  if( translated != null ){
    display = translated;
  }

  return {
    code : codeObj.code,
    display : display,
    system : codeObj.system
  };
}


CodingSystemTranslator.prototype.getTranslatedDisplayForCodeAndLanguage = function( languageCode, system, code ){
  this.maybeLoadTranslationsFromValueSets();
  
  if( system == 'http://documental.ee/fhir/codesystem/questionnaire/type' ){
    system = 'http://documental.ee/fhir/valueset/questionnaires';
  }
  
  if( system == 'http://documental.ee/fhir/codesystem/questionnaire/item' ){
    for( var i in window.questionnaireItemTranslations ){
      if(
        window.questionnaireItemTranslations[ i ].languageCode == languageCode && 
        window.questionnaireItemTranslations[ i ].code == code && 
        window.questionnaireItemTranslations[ i ].system == system
      ){
        
        return window.questionnaireItemTranslations[ i ].display;
      }
    }
  }

  for( var i in window.translations ){
    if(
      window.translations[ i ].languageCode == languageCode && 
      window.translations[ i ].code == code && 
      window.translations[ i ].system == system
    ){
      
      return window.translations[ i ].display;
    }
  }
  
  return null;
}


CodingSystemTranslator.prototype.getTranslatedDisplayForCodeAndCurentLanguage = function( system, code ){
  this.maybeLoadTranslationsFromValueSets();
  
  let languageCode = i18n.language;
  
  if( system == 'http://documental.ee/fhir/codesystem/questionnaire/type' ){
    system = 'http://documental.ee/fhir/valueset/questionnaires';
  }

  
  if( system == 'http://documental.ee/fhir/codesystem/questionnaire/item' ){
    for( var i in window.questionnaireItemTranslations ){
      if(
        window.questionnaireItemTranslations[ i ].languageCode == languageCode && 
        window.questionnaireItemTranslations[ i ].code == code && 
        window.questionnaireItemTranslations[ i ].system == system
      ){
        return window.questionnaireItemTranslations[ i ].display;
      }
    }
  }
  
  for( var i in window.translations ){
    if(
      window.translations[ i ].languageCode == languageCode && 
      window.translations[ i ].system == system && 
      window.translations[ i ].code == code
    ){
      
      return window.translations[ i ].display;
    }
  }
  
  return null;
}


CodingSystemTranslator.prototype.maybeLoadTranslationsFromValueSets = function(){
  if( window.codingTranslationsLoaded ){
    return;
  }
  
  let valueSets = window.appEntityStore.getAllResourcesBySearchParams( {
    'resourceType' : "ValueSet"
  } );

  // TODO: Needs better implementation and actually see which ValueSets are loaded and is there missing some. 
  // Expecting at least 3 ValueSets to set as translated (there is actually more). It's pretty random number
  let translationsLoaded = 0;
  if( valueSets.length > 0 ){ // patient app currentl yhas only 1 valueset
    window.codingTranslationsLoaded = true;
    for( var i in valueSets ) {
      if( this.loadTranslationsFromValueSet( valueSets[ i ] ) ){
        translationsLoaded++;
      }
    }
  }
}


CodingSystemTranslator.prototype.loadTranslationsFromValueSet = function( valueSetResource ){
  let json = valueSetResource.toObject();
  let resourceUrl = json.url;
  let systemUrl = '';

  if( 
    typeof json.compose != 'undefined' && 
    typeof json.compose.include != 'undefined' && 
    typeof json.compose.include[ 0 ] != 'undefined'
  ){
    systemUrl = json.compose.include[ 0 ].system;
  }

  // map resource url to system url                   
  if( resourceUrl == 'http://documental.ee/fhir/valueset/icd10-f' ){
    systemUrl = 'http://hl7.org/fhir/sid/icd-10';
  }
  if( resourceUrl == 'http://documental.ee/fhir/valueset/indication' ){
    systemUrl = 'http://documental.ee/fhir/codesystem/medication/indication';
  }
  if( resourceUrl == 'http://documental.ee/fhir/valueset/atc-f' ){
    systemUrl = 'http://www.whocc.no/atc';
  }
  if( resourceUrl == 'http://documental.ee/fhir/valueset/questionnaires' ){
    systemUrl = 'http://documental.ee/fhir/valueset/questionnaires';
  }
  if( resourceUrl == 'http://documental.ee/fhir/valueset/medication-form' ){
    systemUrl = 'http://documental.ee/fhir/codesystem/medication/form';
  }
  
  if( systemUrl == '' ){
    return false;
  }

  //console.log( systemUrl );
  //console.log( json.compose.include[ 0 ].concept );
  let addedSomeTranslations = false;
  
  if( 
    typeof json.compose != 'undefined' && 
    typeof json.compose.include != 'undefined' && 
    typeof json.compose.include[ 0 ] != 'undefined' && 
    typeof json.compose.include[ 0 ].concept != 'undefined'
  ) {
    for( var i in json.compose.include[ 0 ].concept ){
      if( typeof json.compose.include[ 0 ].concept[ i ].designation != 'undefined' ){
        for( var m in json.compose.include[ 0 ].concept[ i ].designation ){

          let languageCode = json.compose.include[ 0 ].concept[ i ].designation[ m ].language;
          let translatedDisplay = json.compose.include[ 0 ].concept[ i ].designation[ m ].value;
          let code = json.compose.include[ 0 ].concept[ i ].code;
          
          addedSomeTranslations = true;

          if( systemUrl == 'http://documental.ee/fhir/codesystem/questionnaire/item' ){
            window.questionnaireItemTranslations.push( {
              'system' : systemUrl,
              'code' : code,
              'languageCode' : languageCode,
              'display' : translatedDisplay,
            } );
          } else {
            window.translations.push( {
              'system' : systemUrl,
              'code' : code,
              'languageCode' : languageCode,
              'display' : translatedDisplay,
            } );
          }
          
        }
      }

    }
  }

  if( addedSomeTranslations ){
    console.log( 'Loaded translations for system: ' + systemUrl );
  }

  return addedSomeTranslations;
}


export default CodingSystemTranslator;